import { useState } from "react";
import { Link } from "react-router-dom";
import { useGroupApi } from "../../groups/groupApi";
import { CUSTOM_FOOD_MAX, customFoodError } from "../../groups/components/AddFoodModal";
import "../../../styles/DailyFood.css";

// "Can't find the food you're looking for?" Guests may submit too (the server stores guest
// suggestions without a user). Validation is mirrored from the server, which stays authoritative.
export default function FoodSuggestionBox() {
  const { json } = useGroupApi();
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null); // { recipe? } once submitted
  const loggedIn = !!localStorage.getItem("token");

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    const problem = customFoodError(name);
    setError(problem);
    if (problem) return;
    setBusy(true);
    try {
      const r = await json("food-suggestions", "POST", { food_name: name.replace(/\s+/g, " ").trim() });
      setDone(r.status === "exists" ? { recipe: r.recipe } : {});
      setName("");
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <div className="dfSuggest dfSuccess yekan" role="status">
        {done.recipe ? (
          <>
            <p>این غذا همین الان توی فودپلنر هست: «{done.recipe.recipe_name}» 🎉</p>
            <Link to={`/recipe/${done.recipe.recipe_id}`}>دیدن دستور پخت</Link>
          </>
        ) : (
          <p>
            ممنون! <br />بهترین دستور این غذا رو پیدا می‌کنیم و به فودپلنر اضافه‌ش می‌کنیم.
            {loggedIn ? " وقتی اضافه شد بهت خبر می‌دیم." : " اگه وارد حسابت شده باشی، وقتی اضافه شد بهت خبر می‌دیم."}
          </p>
        )}
        <button type="button" onClick={() => setDone(null)}>پیشنهاد یه غذای دیگه</button>
      </div>
    );
  }

  return (
    <form className="dfSuggest" onSubmit={submit} noValidate>
      <p className="dfSuggestText yekan">
        غذای مورد علاقه‌ت رو پیدا نکردی؟ <br />بگو چی دوست داری توی فودپلنر ببینی:
      </p>
      <div className="dfSuggestRow">
        <input
          className="dfInput"
          type="text"
          value={name}
          maxLength={CUSTOM_FOOD_MAX}
          placeholder="مثلا: چیکن آلفردو"
          aria-label="اسم غذایی که می‌خوای اضافه بشه"
          aria-invalid={!!error}
          disabled={busy}
          onChange={(e) => { setName(e.target.value); if (error) setError(""); }}
        />
        <button type="submit" className="dfSubmit" disabled={busy || !name.trim()}>
          {busy ? "..." : "ارسال"}
        </button>
      </div>
      <div className="dfFieldNote yekan">
        {error && <span className="dfFieldError" role="alert">{error}</span>}
        {name.length > CUSTOM_FOOD_MAX - 15 && <span className="dfCount">{name.length}/{CUSTOM_FOOD_MAX}</span>}
      </div>
    </form>
  );
}
